import $ from 'jquery';
import BaseComponent from 'components/BaseComponent';

export default class MobileMastheadComponent extends BaseComponent {
    constructor($element, options) {
        super($element, options);

        this.isTransitioning = false;

        this.init();
    }

    static defaults = {
    }

    SELECTOR = {
        TRIGGER: '[data-mobile-masthead-trigger]',
        MENU: '[data-mobile-masthead-menu]',
    }

    STATE = {
        ACTIVE: 's-isActive',
        LOCKED: 'u-isScrollLocked',
    }

    LISTENER = {
        TRANSITIONEND: [
            'webkitTransitionEnd',
            'msTransitionEnd',
            'transitionend',
        ],
    };

    /**
     * Binds the scope of any handler functions.
     * Should only be run on initialization of the view.
     *
     * @method setupHandlers
     * @returns {MobileMastheadComponent}
     * @private
     */
    setupHandlers() {
        // Bind event handlers scope here
        this.onTriggerClickHander = this.onTriggerClick.bind(this);
        this.onTransitionEndHandler = this.onTransitionEnd.bind(this);
        this.onHashChange = this.onHashChange.bind(this);

        return this;
    }

    /**
     * Handle hash change on search page on mobile. Close the mobile
     * search menu when the hash changes (i.e., when a new search happens)
     * so that the user can see the results.
     *
     * @method onHashChange
     * @private
     */
    onHashChange(e) {
        const $activeTrigger = $('[aria-controls="mobileSearch"]');
        const $menuTarget = this.$element.find(`#mobileSearch`);

        if (!$menuTarget.hasClass(this.STATE.ACTIVE)) {
            return;
        }
        
        this.closeMenu($activeTrigger, $menuTarget);
    }

    /**
     * Create any child objects or references to DOM elements.
     * Should only be run on initialization of the view.
     *
     * @method createChildren
     * @returns {MobileMastheadComponent}
     * @private
     */
    createChildren() {
        super.createChildren();

        this.$trigger = this.$element.find(this.SELECTOR.TRIGGER);
        this.$menu = this.$element.find(this.SELECTOR.MENU);
        this._$document = $('body, html');

        return this;
    }

    /**
     * Remove any child objects or references to DOM elements.
     *
     * @method removeChildren
     * @returns {MobileMastheadComponent}
     * @public
     */
    removeChildren() {
        super.removeChildren();

        return this;
    }

    layout() {
        super.layout();

        return this;
    }

    /**
     * Enables the component.
     * Performs any event binding to handlers.
     * Exits early if it is already enabled.
     *
     * @method enable
     * @returns {MobileMastheadComponent}
     * @public
     */
    enable() {
        if (this.isEnabled) {
            return this;
        }
        this.isEnabled = true;

        this.$trigger.on('click', this.onTriggerClickHander);

        // Loop through brower prefixed event listeners
        for (const transition of this.LISTENER.TRANSITIONEND) {
            document.addEventListener(transition, this.onTransitionEndHandler);
        }

        if (window.location.pathname === '/search') {
            window.addEventListener('hashchange', this.onHashChange);
        }

        return this;
    }

    /**
     * Disables the component.
     * Tears down any event binding to handlers.
     * Exits early if it is already disabled.
     *
     * @method disable
     * @returns {MobileMastheadComponent}
     * @public
     */
    disable() {
        if (!this.isEnabled) {
            return this;
        }
        this.isEnabled = false;


        return this;
    }

    /*
        EVENT HANDLERS
    */
    onTriggerClick(e) {
        if (this.isTransitioning) {
            return;
        }

        const $activeTrigger = $(e.currentTarget);
        const activeMenuId = $activeTrigger.attr('aria-controls');
        const $menuTarget = this.$element.find(`#${activeMenuId}`);

        if ($menuTarget.hasClass(this.STATE.ACTIVE)) {
            this.closeMenu($activeTrigger, $menuTarget);
        } else {
            this.expandMenu($activeTrigger, $menuTarget);
        }
    }

    /**
     * CSS transition end event
     *
     * @method onTransitionEnd
     * @param {event} e
     * @public
     */
    onTransitionEnd(e) {
        this.isTransitioning = false;
    }

    expandMenu($activeTrigger, $menuTarget) {
        this.isTransitioning = true;

        this._$document.addClass(this.STATE.LOCKED);
        this.$menu.removeClass(this.STATE.ACTIVE).height(0);
        this.$trigger.removeClass(this.STATE.ACTIVE);

        $activeTrigger.addClass(this.STATE.ACTIVE);

        $menuTarget.addClass(this.STATE.ACTIVE).height(`${window.innerHeight - 66}px`);
        $activeTrigger.addClass(this.STATE.ACTIVE);
    }

    closeMenu($activeTrigger, $menuTarget) {
        this.isTransitioning = true;

        this._$document.removeClass(this.STATE.LOCKED);
        $activeTrigger.removeClass(this.STATE.ACTIVE);
        $menuTarget.removeClass(this.STATE.ACTIVE).height(0);
    }
}
